import React from "react";
import { Box, Breadcrumbs, Button, Typography } from "@mui/material";
import { CaretRight, Plus } from "@phosphor-icons/react";

export interface GoalGridTopRowProps {
  /** The client name shown as the first breadcrumb (navigable). */
  clientName: string;
  /** Called when the Add Goal button is clicked. */
  onAddGoal: () => void;
  /** Whether to show the Add Goal button */
  showAddGoalButton?: boolean;
}

/**
 * Top row for the Goals grid view. Renders a breadcrumb trail
 * (Client Name → Goals) on the left and an "Add Goal" action button on the right.
 *
 * @param props
 * @param props.clientName - Label for the client breadcrumb link
 * @param props.onClientClick - Handler for navigating back to the client
 * @param props.onAddGoal - Handler for the Add Goal button
 * @param props.showAddGoalButton - Whether to show the Add Goal button
 */
const GoalGridTopRow: React.FC<GoalGridTopRowProps> = ({
  clientName,
  onAddGoal,
  showAddGoalButton = true,
}) => {
  return (
    <Box
      component="header"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }}
    >
      <Breadcrumbs separator={<CaretRight />} aria-label="breadcrumb">
        <Typography variant="body2" aria-current="page">
          {clientName}
        </Typography>
        <Typography variant="body2" aria-current="page">
          Goals
        </Typography>
      </Breadcrumbs>

      {showAddGoalButton && (
        <Button
          variant="contained"
          size="small"
          color="primary"
          startIcon={<Plus />}
          onClick={onAddGoal}
          aria-label="Add goal"
        >
          Add Goal
        </Button>
      )}
    </Box>
  );
};

export default GoalGridTopRow;
